import React from 'react';
import { Link } from 'react-router-dom';
import Image from 'react-bootstrap/Image'
import AppVars from '../../../../AppVars.js';
import { constants } from '../../../../constants/constants'
import ResendLink from '../../Shared/ResendLink'
const appVars = AppVars.getInstance();

class ServiceFailureView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
        }
    }

    render() {
        return (
            <>
                <div role="banner">
                    <div>
                        <Link to={appVars.getAppHomeURL(this.props.style)}><Image className="login-log-resend" src={require('../../../../static/images/Toyota-Logo.svg').default} alt="Toyota" /></Link>
                    </div>
                    <h1 className="title__TO block" style={{ 'marginBottom': '50px', 'marginTop': '79px' }}>
                        {constants.PASSWORD_SERVICE_FAILURE_TITLE}
                    </h1>
                    <div className="block">
                        <div className="subTitle__TO">{constants.PASSWORD_SERVICE_FAILURE_SUBTITLE}</div>
                    </div>
                </div>
                <ResendLink lineText="Need help?" linkAddress="/" linkText="CONTACT US" className="resend-link inline-block" />
            </>
        );
    }
}

export default ServiceFailureView;